import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { CircularProgress, IconButton } from '@mui/material';

import DialogButton from 'retired/DialogButton';

interface Props {
  updating: boolean;
  disabled?: boolean;
  chapterRequestName: string;
  handleEdit: () => void;
  handleRevoke: () => void;
}

export const ActionButtons = ({
  updating,
  disabled = false,
  chapterRequestName,
  handleEdit,
  handleRevoke,
}: Props) => {
  const revokeButton = (
    <DialogButton
      buttonProps={{
        disabled,
      }}
      iconButton
      title={`Are you sure you want revoke "${chapterRequestName}" chapter request?`}
      text="Once confirmed you won't be able to access this chapter request again."
      confirmLabel="Confirm"
      cancelLabel="Cancel"
      handleConfirm={() => {
        handleRevoke();
      }}
    >
      <DeleteIcon />
    </DialogButton>
  );

  return (
    <>
      {updating ? (
        <CircularProgress size={24} />
      ) : (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <IconButton
            title="Edit"
            style={{ flexShrink: 0 }}
            disabled={disabled}
            onClick={handleEdit}
          >
            <EditIcon />
          </IconButton>
          {revokeButton}
        </div>
      )}
    </>
  );
};
